// Global constants
export const COPY_SELECTION = "clipboard/COPY_SELECTION";
export const PASTE_SELECTION = "clipboard/PASTE_SELECTION";
export const RESET_CLIPBOARD = "clipboard/RESET_CLIPBOARD";

// Local constants
export const SET_COPY = "SET_COPY";
export const SET_COPY_PICKS_ONLY = "SET_COPY_PICKS_ONLY";
export const SET_COPY_DRIVES_ONLY = "SET_COPY_DRIVES_ONLY";
